import { useSelector } from 'react-redux'

import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'

export const useGetQuotas = (campaignId?: number) => {
  const orgId = useSelector(selectOrgId)
  const hasCampaignId = campaignId !== undefined && Number.isFinite(campaignId) && campaignId > 0

  return esApi.endpoints.listOrgQuotas.useQuery(
    {
      ...(hasCampaignId ? { campid: campaignId } : {}),
      orgId: orgId?.toString() ?? '',
    },
    { skip: !orgId },
  )
}
